import { c as _c } from "react/compiler-runtime";
/**
 * 상담 신청 랜딩 — CREDENTIALS / RECOGNIZED 섹션.
 * 정부지원사업/창업 프로그램 선정 카드 4개. 각 카드는 주관기관 실제 로고 + 프로그램명 + "선정" 배지.
 * (이전: lucide 인라인 SVG + 그라데이션 칩 → 실제 기관 로고 이미지로 교체)
 */

type Cred = {
  name: string;
  org: string;
  logo: string;
  /** 로고 원본 픽셀 비율 (CLS 방지용 intrinsic width/height) */
  logoWidth: number;
  logoHeight: number;
};
const LOGO_BASE = "/inquiry-landing/investors";
const CREDS: readonly Cred[] = [{
  name: "TIPS",
  org: "민간투자주도형 기술창업 지원",
  logo: `${LOGO_BASE}/tips-logo.png`,
  logoWidth: 370,
  logoHeight: 200
}, {
  name: "창업도약패키지",
  org: "창업진흥원",
  logo: `${LOGO_BASE}/changjinwon-logo.svg`,
  logoWidth: 2000,
  logoHeight: 667
}, {
  name: "초기창업패키지",
  org: "창업진흥원",
  logo: `${LOGO_BASE}/changjinwon-logo.svg`,
  logoWidth: 2000,
  logoHeight: 667
}, {
  name: "서울혁신챌린지",
  org: "서울경제진흥원",
  logo: `${LOGO_BASE}/sba-logo.png`,
  logoWidth: 300,
  logoHeight: 169
}];
const CheckBadgeIcon = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="h-[13px] w-[13px]">
    <path d="m5 12 5 5 9-11" />
  </svg>;
const Recognized = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-[13px] font-semibold uppercase tracking-wide text-[#6a6d75]">Recognized</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mx-auto flex max-w-[680px] flex-col items-center gap-3 text-center">{t0}<h2 className="text-balance break-keep font-[family-name:var(--font-nanum-square-neo)] text-[30px] font-extrabold leading-[1.35] tracking-[-0.84px] text-[#121212] sm:text-[34px] lg:text-[40px] lg:tracking-[-1.2px]">정부지원사업에 선정된 <span className="font-black text-[#7a33ff]">검증된 기업</span>입니다</h2><p className="text-balance break-keep text-[16px] leading-[1.6] text-[#374151] sm:text-[16px] lg:text-[17px]">TIPS를 비롯한 주요 정부지원사업과 창업 프로그램에 선정되며 기술력과 사업성을 인정받았습니다.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section id="recognized" className="w-full bg-[#f6f7fb]"><div className="mx-auto max-w-[1140px] px-5 pb-16 lg:px-0 lg:pb-20">{t1}<ul className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-12 lg:grid-cols-4">{CREDS.map(_temp)}</ul></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Recognized;
function _temp(cred) {
  return <li key={cred.name} className="flex flex-col items-center rounded-[22px] border border-[#e1e9f3] bg-white px-6 pb-[26px] pt-[30px] text-center transition duration-300 hover:-translate-y-1.5 hover:border-[#cfdbec] hover:shadow-[0_18px_50px_-18px_rgba(13,40,100,0.18)]"><span className="mb-4 flex h-11 items-center justify-center"><img src={cred.logo} alt={`${cred.org} 로고`} width={cred.logoWidth} height={cred.logoHeight} loading="lazy" className="h-11 w-auto object-contain" /></span><p className="text-[17px] font-bold tracking-[-0.34px] text-[#121212]">{cred.name}</p><p className="mt-[5px] text-[13px] font-semibold text-[#7e8da3]">{cred.org}</p><span className="mt-[15px] inline-flex items-center gap-[5px] rounded-full bg-[#d8fbf3] px-3 py-[5px] text-[12px] font-bold text-[#00c4a7]">{CheckBadgeIcon}선정</span></li>;
}